import React from 'react';
// import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
// Components
import SmallModalContainer from './common/SmallModalContainer';
// Icons
import iconError from '../assets/icons/icon_circle-error.svg';

const ErrorModal = ({ open, handleClose }) => {
  const handleReload = () => {
    handleClose();
  };

  return (
    <SmallModalContainer open={open} onClose={handleClose}>
      <Box display="flex" flexDirection="column" gap={'1rem'}>
        <Box
          component="img"
          sx={{ width: '54px', height: '54px' }}
          alt="img not found"
          src={iconError}
        />
        <Typography variant="h1">Hubo un problema</Typography>
        <Typography variant="h4" component="p">
          Por favor, intentá más tarde.
        </Typography>
        <Box display="flex" gap={'1rem'} marginTop="1.5rem">
          <Button
            onClick={() => handleReload()}
            variant="contained"
            sx={{ height: '48px', borderRadius: '16px', width: '100%' }}>
            <Typography variant="tabs" component="span">
              Entendido
            </Typography>
          </Button>
        </Box>
      </Box>
    </SmallModalContainer>
  );
};

export default ErrorModal;
